import { useCallback, useState } from 'react'
import { useFindStockAlmacenWithTransitMutation } from '../../SliceLogistica'
import { StockAlmacenENTITY } from 'sigo-entities'
import { useSelector } from 'react-redux'
import { RootState } from '../../AdapterStore'
import { useStockAlmacenEquiposRepository } from './useStockAlmacenEquiposRepository'
import { indexedDB } from '../../useIndexedDB'

interface Params {
    pipeline: any[]
}

export const useStockAlmacenRepository = (loadEquipment?: boolean) => {
    const { user } = useSelector((state: RootState) => state.auth)

    const [findStockAlmacenWithTransit, { isError, error }] = useFindStockAlmacenWithTransitMutation()
    const { findStockAlmacenEquipos, isError: isErrorFindStock, error: errorFindStock } = useStockAlmacenEquiposRepository()

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState<StockAlmacenENTITY[]>([])

    const loadData = useCallback(async ({ pipeline }: Params) => {
        setIsLoading(true)
        try {
            // ONLINE
            if (navigator.onLine) {
                const response = await findStockAlmacenWithTransit({
                    pais: user.Pais.Codigo,
                    delegacion: user.Delegacion.Codigo,
                    pipeline
                }).unwrap()
                const now = Date.now()

                await indexedDB.stock_almacen.clear()
                await indexedDB.stock_almacen.bulkPut(response.map(item => ({
                    ...item,
                    pendingSync: 0,
                    updatedAt: now,
                    syncedAt: now
                })))

                if (loadEquipment) {
                    const pipeline = [{
                        $match: {
                            ID_StockAlmacen: {
                                $in: response.map(item => item.ID_StockAlmacen)
                            }
                        }
                    }]
                    await findStockAlmacenEquipos({ pipeline })
                }

                setData(response)
                return response
            }
            // OFFLINE
            const localData = await indexedDB.stock_almacen.toArray()
            setData(localData)
            return localData
        } finally {
            setIsLoading(false)
        }
    }, [findStockAlmacenWithTransit, findStockAlmacenEquipos])

    return {
        data,
        isLoading,
        loadData,
        isError: isError || isErrorFindStock,
        error: error || errorFindStock
    }
}